var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('HeaderMenu'),_c('div',{staticClass:"main"},[_c('LoginBox')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }